export default __webpack_public_path__ + "static/media/icon-pending.04a99ee2.svg";